import { useTranslation } from "react-i18next";
import Button from "../../Button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../state/store";
import { obtainAuthorizationToken } from "../../../state/agencies/action";
import { Agency } from "../../../models/Agency";
import { useEffect, useState } from "react";
import { Toast } from "../../Toast";
import { LoadingMask } from "../../LoadingMask";
import { ToastContainer } from "react-toastify";
import { ObtainAuthorizationTokenModal } from "./ObtainAuthorizationTokenModal";

interface Props {
    currentAgency: Agency
}

export const AuthorizationTokenModule = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const isTokenLoading = useSelector((state: any) => state.agencies.isLoadingToken);

    const [showError, setShowError] = useState(false);
    const error = useSelector((state: any) => state.agencies.error);

    const [ showObtainAuthorizationTokenModal, setShowObtainAuthorizationTokenModal] = useState<{
        show: boolean;
        token: string
    }>({ show: false, token: "" });

    useEffect(() => {
        if (showError) {
            Toast(t(error?.reason ?? "SOMETHING_WENT_WRONG"), t(error?.cause_info));
            setShowError(false);
        }
    }, [showError, error, t]);

    const getAuthorizationToken = async () => {
        dispatch(obtainAuthorizationToken(props.currentAgency.id)).then((e) => {
        if (e.type === "agencies/obtainAuthorizationToken/rejected") {
            setShowError(true);
        } else {
            console.log(e.payload);
            setShowObtainAuthorizationTokenModal({ show: true, token: e.payload });
        }
        });
    };

    return(
        <>
            {isTokenLoading && <LoadingMask />}
            <ToastContainer progressStyle={{ background: "#D4AF37" }} />
            <ObtainAuthorizationTokenModal
                info={showObtainAuthorizationTokenModal}
                onClose={() => setShowObtainAuthorizationTokenModal({ show: false, token: "" })}
            />
            <div className="text-black max-h-full p-5 md:w-full">
                <div className="flex justify-between w-full">
                    <div className="text-md font-bold text-black pl-3 mt-2">
                        {t("AUTHORIZATION_TOKEN")}
                    </div>
                    <Button onClick={() => getAuthorizationToken()}>
                        <span className="flex items-center font-semibold pr-3">
                        <div className="w-8 p-1 aspect-square mr-2">
                            <PlusIcon />
                        </div>
                        {t("OBTAIN_TOKEN")}
                        </span>
                    </Button>
                </div>
                <div>
                    <p className="pl-3 mt-5">{t("AUTHORIZATION_TOKEN_MESSAGE")}</p>
                </div>
            </div>
        </>
    )
}